export { default } from './FlowLogs.container'



// WEBPACK FOOTER //
// ./src/pages/FlowLogs/index.js